import DistrictArea from './district_area.vue';

export default DistrictArea;
